// Schémas Zod de validation des entrées d'authentification.
// Partagés client/serveur : le client peut valider avant envoi, le serveur revalide
// TOUJOURS (toute donnée venant du navigateur est considérée non fiable).

import { z } from 'zod'

// E-mail normalisé : sans espaces superflus, en minuscules, format valide.
export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email('Adresse e-mail invalide.')
  .max(254, 'Adresse e-mail trop longue.')

// Mot de passe : au moins 12 caractères (recommandation ANSSI), borné à 72 (limite bcrypt,
// au-delà de laquelle l'algorithme tronque silencieusement).
export const passwordSchema = z
  .string()
  .min(12, 'Le mot de passe doit comporter au moins 12 caractères.')
  .max(72, 'Le mot de passe ne doit pas dépasser 72 caractères.')

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
})
export type RegisterInput = z.infer<typeof registerSchema>

// À la connexion, on ne réimpose pas les règles de complexité (un mot de passe
// historique pourrait ne plus les respecter) : on exige seulement un champ non vide.
export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Mot de passe requis.'),
})
export type LoginInput = z.infer<typeof loginSchema>
